"use client";
import { useSite } from "@/lib/hooks/site";
import Image from "next/image";
import FacebookIcon from "@/components/hero-icons/facebook-icon";
import InstagramIcon from "@/components/hero-icons/instagram-icon";
import LinkedinIcon from "@/components/hero-icons/linkedin-icon";
import VimeoIcon from "@/components/hero-icons/vimeo-icon";
import PinterestIcon from "@/components/hero-icons/pinterest-icon";

function ListSocialPlatforms() {
  const site = useSite();

  if (!site.setting?.social) return null;

  const socials = [
    {
      Icon: <FacebookIcon className="text-[#1877F2] w-4 h-4" />,
      title: "Facebook",
      path: site.setting.social?.facebook,
    },
    {
      Icon: <InstagramIcon className="text-[#E1306C] w-4 h-4" />,
      title: "Instagram",
      path: site.setting.social?.instagram,
    },
    {
      // eslint-disable-next-line @next/next/no-img-element
      Icon: (
        <Image
          src="/threads.svg"
          loader={({ src }) => src}
          alt="threads"
          width={16}
          height={16}
          className="w-4 h-4"
        />
      ),
      title: "Threads",
      path: site.setting.social?.thread,
    },
    {
      Icon: <VimeoIcon className="text-[#1AB7EA] w-4 h-4" />,
      title: "Vimeo",
      path: site.setting.social?.vimeo,
    },
    {
      Icon: <LinkedinIcon className="text-[#0A66C2] w-4 h-4" />,
      title: "LinkedIn",
      path: site.setting.social?.linkedin,
    },
    {
      Icon: <PinterestIcon className="text-[#CA2028] w-4 h-4" />,
      title: "Pinterest",
      path: site.setting.social?.pinterest,
    },
    {
      // eslint-disable-next-line @next/next/no-img-element
      Icon: (
        <Image
          loader={({ src }) => src}
          src="/twitter.svg"
          height={16}
          width={16}
          alt="twitter"
          className="w-4 h-4"
        />
      ),
      title: "X",
      path: site.setting.social?.twitter,
    },
  ];

  const getSocials = () => {
    return socials.filter((item: any) => item.path);
  };

  if (!getSocials().length) return null;

  return (
    // <div className="flex flex-col gap-2 px-4 py-6  border-t border-slate-300">
    <div className="flex flex-col gap-2 px-4 py-2">
      {/*<div className="flex justify-center items-center">*/}
      {/*    <span className="text-xs text-black font-medium">Takip Edin</span>*/}
      {/*</div>*/}

      <div className="flex justify-center items-center flex-col gap-2">
        <div className="flex gap-2">
          {getSocials()
            .slice(0, 3)
            .map((item: any, index) => (
              <SocialPlatform key={index} {...item} />
            ))}
        </div>

        <div className="flex gap-2">
          {getSocials()
            .slice(3, 6)
            .map((item: any, index) => (
              <SocialPlatform key={index} {...item} />
            ))}
        </div>
      </div>
    </div>
  );
}

function SocialPlatform(props: { Icon: any; title: string; path: string }) {
  const { Icon, title, path } = props;

  if (!path) return null;

  return (
    <a target="_blank" href={path} rel="noopener noreferrer nofollow">
      <div className="flex p-1 gap-2 items-center justify-center bg-stone-50 rounded-2xl py-1 px-2">
        <div className="flex justify-center items-center">{Icon}</div>
        <span className="text-sm text-slate-800 font-semibold">{title}</span>
      </div>
    </a>
  );
}

export default ListSocialPlatforms;
